import { render, staticRenderFns } from "./QuestionsCreate.vue?vue&type=template&id=48b805ba&scoped=true"
import script from "./QuestionsCreate.vue?vue&type=script&lang=js"
export * from "./QuestionsCreate.vue?vue&type=script&lang=js"
import style0 from "./QuestionsCreate.vue?vue&type=style&index=0&id=48b805ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b805ba",
  null
  
)

export default component.exports